import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ProofResponse, ProofStatus, ReviewProofRequest, UploadProofRequest } from '../types/domain';

export interface ProofImageFetcher { baseUrl: string; getToken: () => string | null | undefined; fetch?: typeof fetch; }

async function fetchBlob(img: ProofImageFetcher, path: string): Promise<Blob> {
  const doFetch = img.fetch ?? globalThis.fetch;
  const token = img.getToken();
  const res = await doFetch(`${img.baseUrl.replace(/\/+$/, '')}${path}`, { headers: token ? { authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`Imagen HTTP ${res.status}`);
  return res.blob();
}

export function proofEndpoints(http: HttpClient, img?: ProofImageFetcher) {
  return {
    // coach-side
    list: (status?: ProofStatus) => http.get<ApiEnvelope<ProofResponse[]>>('/v1/payment-proofs', { query: { status } }).then(unwrap),
    review: (id: string, body: ReviewProofRequest) => http.post<ApiEnvelope<ProofResponse>>(`/v1/payment-proofs/${id}/review`, body).then(unwrap),
    fetchImageBlob: (id: string): Promise<Blob> => {
      if (!img) throw new Error('ProofImageFetcher no configurado');
      return fetchBlob(img, `/v1/payment-proofs/${id}/image`);
    },
    // client-side
    listMine: () => http.get<ApiEnvelope<ProofResponse[]>>('/v1/me/payment-proofs').then(unwrap),
    upload: (body: UploadProofRequest) => http.post<ApiEnvelope<ProofResponse>>('/v1/me/payment-proofs', body).then(unwrap),
    myImageBlob: (id: string): Promise<Blob> => {
      if (!img) throw new Error('ProofImageFetcher no configurado');
      return fetchBlob(img, `/v1/me/payment-proofs/${id}/image`);
    },
  };
}
export type ProofEndpoints = ReturnType<typeof proofEndpoints>;
